import { render } from "./SidenavList.vue?vue&type=template&id=74b5e042&scoped=true"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=74b5e042&scoped=true&lang=css"
import "./SidenavList.vue?vue&type=style&index=1&id=74b5e042&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b5e042"]])

export default __exports__